<template>
  <reportingBug ref="reportingbug" />
</template>

<script>
import reportingBug from "../../../components/form/reportingBug/reportingBug.vue";
export default {
  name: "Reportingbug",
  components: {
    reportingBug,
  },
};
</script>
